import { action, makeObservable, observable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class RisingRiskStore {
  selectedDiseaseName = '';
  listOfDiseases = [];
  membersUniqueList: any[] = [];

  constructor() {
    makeObservable(this, {
      selectedDiseaseName: observable,
      listOfDiseases: observable,
      membersUniqueList: observable,
      setSelectedDiseaseName: action,
      removeSelectedDiseaseName: action,
      setListOfDiseases: action,
      removeListOfDiseases: action,
      setMembersUniqueList: action,
      removeMembersUniqueList: action,
    });
    makePersistable(this, {
      name: 'RisingRiskStore',
      properties: [
        'selectedDiseaseName',
        'listOfDiseases',
        'membersUniqueList',
      ],
      storage: window.localStorage,
    });
  }

  setSelectedDiseaseName(selectedDiseaseName: string) {
    this.selectedDiseaseName = selectedDiseaseName;
  }

  removeSelectedDiseaseName() {
    this.selectedDiseaseName = '';
  }

  setListOfDiseases(listOfDiseases: any) {
    this.listOfDiseases = listOfDiseases;
  }

  removeListOfDiseases() {
    this.listOfDiseases = [];
  }

  setMembersUniqueList(membersUniqueList: any[]) {
    this.membersUniqueList = membersUniqueList;
  }

  removeMembersUniqueList() {
    this.membersUniqueList = [];
  }
}
